//
//
//
//
//
//
//

import PageResult from "@/components/comResult/comPageResult.vue";
import $manager from "@/Manager/04.Sms/ShopActivitySalesCheckOrder2.js";

export default {
  components: {
    "page-result": PageResult
  },
  data() {
    return {
      isFormInit: false,
      orderItem: null,

      dataConfig: {
        IsShowClose: false,
        Title: "操作成功",
        Icon: "success",
        ButtonList: []
      }
    };
  },

  async created() {
    await this.loadOrderData();
  },
  methods: {
    setOrderItem(orderItem) {
      this.orderItem = orderItem;
      this.isFormInit = true;

      var title="提交成功";
      this.dataConfig.Title = title;
      
      // var desc =
      //   "2内容详情，可根据实际需要安排，如果换行则不超过规定长度，居中展现<a href='javascript:void(0);'>文字链接</a>";
      // this.dataConfig.Desc = desc;

      var button = {
        type: "primary",
        text: "1.查看活动提报",
        onClick: () => {
          var url = "/Sms/ShopActivitySalesCheckOrder2/Detail?openId=" + this.orderOpenId;
          this.$path.to(url);
        }
      };
      this.dataConfig.ButtonList.push(button);

      button = {
        type: "primary",
        text: "2.活动提报列表",
        onClick: () => {
          var url = "/Sms/ShopActivitySalesCheckOrder2/Index";
          this.$path.to(url);
        }
      };
      this.dataConfig.ButtonList.push(button);

      // button = {
      //   type: "default",
      //   text: "3.返回工作台",
      //   onClick: () => {
      //     var url = "/Tpl/Template2/Detail?openId=" + this.orderOpenId;
      //     this.$path.to(-1);
      //   }
      // };
      // this.dataConfig.ButtonList.push(button);

    },

    async loadOrderData() {
      var openId = this.$route.query.openId;
      console.log("openId", openId);
      if (!openId) {
        this.$msg.alert("找不到单据标识[openId]");
        return;
      }

      this.$msg.showLoading("正在验证...");

      var result = await $manager.getByOpenId(openId);
      this.$msg.hideLoading();

      if (result && result.state == 1) {
        this.$msg.succ(result.msg);
        this.orderOpenId = openId;
        var orderItem = result.data;
        this.setOrderItem(orderItem);
        return;
      }
      console.log("result", result);
      this.$msg.alert(result.msg);
    }
  }
};
